import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { BsgShoeSize } from '../../api/models';

export type TABLE_TYPE = Table<BsgShoeSize>;

export const TABLE = 'bsgShoeSize';
const SCHEMA = 'bsgShoeSizeId, sortId';

class BsgShoeSizeDatabase implements DataRepository<BsgShoeSize> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<BsgShoeSize | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: BsgShoeSize, key: Key): Promise<BsgShoeSize> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: BsgShoeSize[]): Promise<BsgShoeSize[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<BsgShoeSize[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const BsgShoeSizeDB = new BsgShoeSizeDatabase(db);
